import {
  ARRAY_PARAM_KEYS,
  normalizeSearch,
  type PerformanceReportSearch,
  SCALAR_PARAM_KEYS,
} from "@partners/ui";
import { createFileRoute } from "@tanstack/react-router";

/**
 * Search-param schema for the Performance Report deep-linking (PART-4034).
 * `validateSearch` cannot live in `performance.lazy.tsx` (a
 * `createLazyFileRoute` module) so this non-lazy sibling carries it, mirroring
 * the `marketing/index.tsx` + `index.lazy.tsx` split.
 *
 * Reference: https://tanstack.com/router/latest/docs/guide/code-splitting#how-does-tanstack-router-split-code
 *
 * This only does SHAPE validation via the codec's tolerant `normalizeSearch`
 * — it absorbs comma-separated values, repeated keys, a mix of both, and
 * number/boolean coercion, re-emitting canonical comma-joined strings.
 * Whitelisting against the fetched filter-option sets happens in the page
 * component once those options resolve (the route can't await an async API
 * here); see `apps/portal/src/pages/PerformanceReport/urlParamsSchema.ts`.
 */
export const Route = createFileRoute("/_authenticated/_IBComplete/performance")(
  {
    validateSearch: (
      search: Record<string, unknown>,
    ): PerformanceReportSearch =>
      normalizeSearch(search, ARRAY_PARAM_KEYS, SCALAR_PARAM_KEYS),
  },
);
